import React from 'react'
import PropTypes from 'prop-types'
import TimelineBlock from 'components/organisms/timeline-block'
import { Alert } from 'reactstrap'

const propTypes = {
  data: PropTypes.object
}

const TimelineTracking = ({ data }) => (
  <div
    className="timeline timeline-one-side"
    data-timeline-axis-style="dashed"
    data-timeline-content="axis"
  >
    {
      data && data.map((data, index) => (
        <TimelineBlock
          key={ index }
          color={ 'default' }
          time={ data.timestamp }
          title={ data.message }
        />
      ))
    }
    {
      data && data.length === 0 && (
        <Alert color='info'>
          <i className='fas fa-info-circle mr-3' />
          <span>{ 'The shipments info hasn\'t been updated yet.' }</span>
        </Alert>
      )
    }
  </div>
)

TimelineTracking.propTypes = propTypes

export default TimelineTracking
